export const urls = {
  fetchPlanDetails: ({ code }) => `/api/v1/membership?code=${code}`,
  fetchAllPlanDetails: () => `/api/v1/membership/plans`,
  fetchActiveMembership: () => `/api/v1/membership/active`,
  setFreeMembership: ({ code }) => `/api/v1/membership?code=${code}`,
  verifyBinancePayment: ({ orderId }) =>
    `/api/v1/pg/binance-pay/verify-order?orderId=${orderId}`,
};
